module.exports = __webpack_public_path__ + "img/kl_smsy.efa9c918.png";